import React from "react";
import PropTypes from "prop-types";

import { SideNavigation } from "@cloudscape-design/components";
import { withViews } from "../ViewContext";
import { useNavigate, useLocation } from "react-router-dom";

export const generateCatUrl = (view, param) => {
  return `/query/${view}/${encodeURIComponent(param)}`;
};
const generateNavItems = (response) => {
  if (!response) return {};
  const mouseItems = response.map((item) => {
    return {
      type: "link",
      text: item.title,
      href: `/query/${item.id}`,
    };
  });
  const viewNav = [
    {
      type: "section",
      text: "Views",
      items: mouseItems,
    },
  ];
  return [/*...baseNav,*/ ...viewNav];
};

function NavComponent({ views, href }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [navItems, setNavItems] = React.useState(null);

  React.useEffect(() => {
    if (views && !navItems) {
      setNavItems(generateNavItems(views));
    }
  }, [views, navItems]);

  if (navItems) {
    return (
      <SideNavigation
        activeHref={href || location.pathname}
        items={navItems}
        onFollow={(event) => {
          event.preventDefault();
          navigate(event.detail.href);
        }}
      />
    );
  }
  return null;
}
NavComponent.propTypes = {
  href: PropTypes.string,
  views: PropTypes.array,
};
export default withViews(NavComponent);
